export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-600 mb-10">
            欢迎漫画爱好者投稿、合作或提出建议，一起让<strong>漫画分类</strong>体验变得更好
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            <div className="p-6 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-serif font-semibold text-base text-foreground-900 mb-2">投稿合作</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                如果你有原创漫画或推荐内容想要分享，欢迎通过邮件联系我们，
                优秀作品将获得首页推荐位展示。
              </p>
              <p className="text-sm text-primary-500 font-medium mt-3 break-all">tougao@tuhao-comic.com</p>
            </div>

            <div className="p-6 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100 text-accent-500 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-xl"></i>
              </div>
              <h3 className="font-serif font-semibold text-base text-foreground-900 mb-2">意见反馈</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                使用过程中遇到任何问题或有改进建议？我们非常重视每一位读者的意见和反馈。
              </p>
              <p className="text-sm text-accent-500 font-medium mt-3 break-all">feedback@tuhao-comic.com</p>
            </div>

            <div className="p-6 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-secondary-100 text-secondary-600 flex items-center justify-center">
                <i className="ri-shake-hands-line text-xl"></i>
              </div>
              <h3 className="font-serif font-semibold text-base text-foreground-900 mb-2">商务洽谈</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                广告投放、品牌合作、资源互换等商务合作需求，请通过邮件与我们取得联系。
              </p>
              <p className="text-sm text-secondary-600 font-medium mt-3 break-all">business@tuhao-comic.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}